import { Optional } from 'packages/types'
import { useI18n } from 'builder/hooks/useI18n'
import { PersonalEditorField } from './PersonalEditorField'

type Props = {
  value: Optional<string>
  name: string
}

export const Email = (props: Props) => {
  const { i18n } = useI18n()
  const { value, name } = props

  return (
    <>
      {/* Email */}
      <PersonalEditorField
        label={i18n.t('builder.resume_editor.email')}
        value={value || ''}
        name={name}
      />
    </>
  )
}
